import { ReactElement } from "react";
import { Routes, Route } from "react-router-dom";

import RequireAuth from "global-components/requireAuth/RequireAuth";
import CustomLoginCallback from "global-components/customLoginCallback/CustomLoginCallback";

import PageAlert from "global-components/pageAlert/PageAlert";
import Home from "pages/home/home";
import EditProfile from "pages/editProfile/editProfile";
import Mfa from "pages/mfa/mfa";
import ChangePassword from "pages/changePassword/changePassword";

import { Page404 } from "pages";

import {
  PATH_TO_HOME,
  PATH_TO_LOGIN_CALLBACK,
  PATH_TO_EDIT_PROFILE,
  PATH_TO_MFA,
  PATH_TO_CHANGE_PASSWORD,
} from "constants/navigation";

import styles from "./viewport.module.css";

export default function Viewport(): ReactElement {
  return (
    <div aria-label="app-viewport" className={styles.viewport}>
      <PageAlert />

      <Routes>
        <Route
          path={PATH_TO_HOME}
          element={<RequireAuth render={() => <Home />} />}
        />
        <Route
          path={PATH_TO_EDIT_PROFILE}
          element={<RequireAuth render={() => <EditProfile />} />}
        />
        <Route
          path={PATH_TO_MFA}
          element={<RequireAuth render={() => <Mfa />} />}
        />
        <Route
          path={PATH_TO_CHANGE_PASSWORD}
          element={<RequireAuth render={() => <ChangePassword />} />}
        />

        <Route
          path={PATH_TO_LOGIN_CALLBACK}
          element={<CustomLoginCallback />}
        />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </div>
  );
}
